/* import __COLOCATED_TEMPLATE__ from './snooze-button-popover-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();